import * as React from 'react';
import { SVGProps } from 'react';

const SvgSearch = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.864 14.321h-.813l-.288-.278a6.656 6.656 0 0 0 1.616-4.353 6.69 6.69 0 1 0-6.689 6.689c1.657 0 3.18-.607 4.353-1.616l.278.288v.813L19.467 21 21 19.467l-5.136-5.146zm-6.174 0c-2.563 0-4.631-2.069-4.631-4.631S7.128 5.059 9.69 5.059c2.563 0 4.631 2.069 4.631 4.631s-2.069 4.631-4.631 4.631z" />
  </svg>
);

export default SvgSearch;
